import type { OnyxTableNotFound } from '@onyx/angular';

const I18N = 'bases.assignedVehicles.empty';

export const BASE_ASSIGNED_VEHICLES_NOT_FOUND: OnyxTableNotFound = {
  icon: { name: 'menu-fleet-filled', size: 32 },
  title: `${I18N}.title`,
  text: `${I18N}.text`,
};
